import { Moment } from 'moment-timezone';

export type SaveTask = MedicationTask | FeedingTask;

type TaskBase = {
    uuid: string;
    date: Moment;
    instructions?: string;
};

export interface MedicationTask extends TaskBase {
    name: string;
    dosage: DosageQuantity;
    methodType: number;
}

export interface FeedingTask extends TaskBase {
    brand?: string;
    foodType: number;
    momentTypeId: number;
    foodProvisionType: number;
    quantity: DosageQuantity;
}

export interface DosageQuantity {
    quantity: number;
    unit: number;
}

export const isMedicationTask = (task: SaveTask): task is MedicationTask => {
    return 'dosage' in task;
};

export const isFeedingTask = (task: SaveTask): task is FeedingTask => {
    return 'quantity' in task;
};
